"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = exports.TEXT_TYPE = exports.TEXT_DISPLAY_FORMAT = exports.DEFAULT_TEXT_LIMIT = exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_SHIMMER_CONTINUE_SEARCH = exports.DEFAULT_PLACE_HOLDER_BACKGROUND = exports.DEFAULT_ICON_SIZE = exports.DEFAULT_ICON_COLOR = exports.DEFAULT_CARD_WIDTH = exports.DEFAULT_CARD_HEIGHT = exports.DEFAULT_BORDER_RADIUS = exports.ARR_TEXT_TYPE = exports.ARR_COLUMN_SPAN = void 0;
var _theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme/lib/AirasiaClassic/theme"));
var TEXT_TYPE = {
  default: {
    type: 'default',
    size: 'normal',
    lineHeight: 'normal'
  },
  sub: {
    type: 'sub',
    size: 'small',
    lineHeight: 'large'
  },
  small: {
    type: 'small',
    size: 'XSmall',
    lineHeight: 'small'
  },
  titleNormal: {
    type: 'titleNormal',
    size: 'titleNormal',
    lineHeight: 'titleSmall'
  },
  medium: {
    type: 'medium',
    size: 'medium',
    lineHeight: 'small'
  },
  titleSmall: {
    type: 'titleSmall',
    size: 'titleSmall',
    lineHeight: 'titleSmall'
  },
  textSmall: {
    type: 'small',
    size: 'small',
    lineHeight: 'small'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var ARR_TEXT_TYPE = Object.keys(TEXT_TYPE);
exports.ARR_TEXT_TYPE = ARR_TEXT_TYPE;
var DEFAULT_ICON_COLOR = 'greyDark';
exports.DEFAULT_ICON_COLOR = DEFAULT_ICON_COLOR;
var DEFAULT_TEXT_COLOR = 'default';
exports.DEFAULT_TEXT_COLOR = DEFAULT_TEXT_COLOR;
var DEFAULT_CARD_WIDTH = '180px';
exports.DEFAULT_CARD_WIDTH = DEFAULT_CARD_WIDTH;
var DEFAULT_CARD_HEIGHT = '100%';
exports.DEFAULT_CARD_HEIGHT = DEFAULT_CARD_HEIGHT;
var DEFAULT_PLACE_HOLDER_BACKGROUND = 'default';
exports.DEFAULT_PLACE_HOLDER_BACKGROUND = DEFAULT_PLACE_HOLDER_BACKGROUND;
var DEFAULT_TEXT_LIMIT = 20;
exports.DEFAULT_TEXT_LIMIT = DEFAULT_TEXT_LIMIT;
var DEFAULT_ICON_SIZE = 'normal';
exports.DEFAULT_ICON_SIZE = DEFAULT_ICON_SIZE;
var DEFAULT_BORDER_RADIUS = '4px 4px 0px 0px';
exports.DEFAULT_BORDER_RADIUS = DEFAULT_BORDER_RADIUS;
var ARR_COLUMN_SPAN = ['2', '3', '4', '1'];
exports.ARR_COLUMN_SPAN = ARR_COLUMN_SPAN;
var TEXT_DISPLAY_FORMAT = ['row', 'column'];
exports.TEXT_DISPLAY_FORMAT = TEXT_DISPLAY_FORMAT;
var DEFAULT_SHIMMER_CONTINUE_SEARCH = {
  COLUMNSPAN: '3',
  BORDER_RADIUS: _theme.default.borderRadius.normal
};
exports.DEFAULT_SHIMMER_CONTINUE_SEARCH = DEFAULT_SHIMMER_CONTINUE_SEARCH;
var TOKENS = {
  DEFAULT_IMAGE_WIDTH: '100%',
  DEFAULT_IMAGE_PRODUCT_CARD: '100px',
  TITLE: {
    SIZE: 'default',
    COLOR: 'neutral'
  }
};
exports.TOKENS = TOKENS;